import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useIsAdmin } from "@/hooks/useUserRole";
import { LinkedinImportPanel } from "@/components/admin/LinkedinImportPanel";
import { Linkedin } from "lucide-react";
import { Navigate } from "react-router-dom";

export default function LinkedinImports() {
  usePageMeta({
    title: "Importação LinkedIn - Data Hire Club",
    description: "Logs e controle da importação automática de vagas do LinkedIn",
    noindex: true,
  });

  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <CandidateLayout maxWidth="6xl">
        <p className="text-muted-foreground">Carregando...</p>
      </CandidateLayout>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/candidate/dashboard" replace />;
  }

  return (
    <CandidateLayout maxWidth="6xl">
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Linkedin className="h-7 w-7 text-primary" />
          <div>
            <h1 className="text-2xl font-bold text-foreground">Importação LinkedIn</h1>
            <p className="text-sm text-muted-foreground">
              Controle o robô de importação de vagas e acompanhe o histórico de execuções
            </p>
          </div>
        </div>

        <LinkedinImportPanel />
      </div>
    </CandidateLayout>
  );
}
